import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Accordion from "@material-ui/core/Accordion";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import Typography from "@material-ui/core/Typography";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import { faBullseye } from "@fortawesome/free-solid-svg-icons";
import SystemLabel from "../../../../system/SystemLabel/SystemLabel";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    fontWeight: theme.typography.fontWeightRegular,
  },
}));

export default function CollapsePanel({ name, icon, children, dark = false, open = false }) {
  const classes = useStyles();
  const [expanded, setExpanded] = React.useState(open);
  return (
    <div className={classes.root} style={{ margin: "10px 0px" }}>
      <Accordion expanded={expanded} onChange={() => setExpanded(!expanded)}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon className="secondary-text" />}
          aria-controls="panel1a-content"
          className="dark-l3"
          style={{ maxHeight: 55, minHeight: 55 }}
          id="panel1a-header"
        >
          {icon}
          <div style={{ marginLeft: 10 }} className="primary-text">
            {"  "} <SystemLabel name={name} />
          </div>
        </AccordionSummary>
        <AccordionDetails className="dark-l1" style={{ display: "block" }}>
          {children}
        </AccordionDetails>
      </Accordion>
    </div>
  );
}
